export default {
  type: {
    label: 'User Type',
    placeholder: 'Add user type',
    system: {
      name: 'user_level_id',
    },
    value: '',
    errors: [],
    type: 'text',
    name: 'type',
    rules: {
      title: 'Type field',
      required: true,
    }
  },
  username: {
    label: 'User Name',
    placeholder: 'Add user name',
    system: {
      name: 'username',
    },
    value: '',
    errors: [],
    type: 'text',
    name: 'username',
    rules: {
      title: 'User name field',
      required: true,
    }
  },
  firstname: {
    label: 'First Name',
    placeholder: 'Add first name',
    system: {
      name: 'firstname',
    },
    value: '',
    errors: [],
    type: 'text',
    name: 'firstname',
    rules: {
      title: 'Firs name field',
      required: true,
    }
  },
  lastname: {
    label: 'Last Name',
    placeholder: 'Add last name',
    system: {
      name: 'lastname',
    },
    value: '',
    errors: [],
    type: 'text',
    name: 'lastname',
    rules: {
      title: 'Last name field',
      required: true,
    }
  },
  password: {
    label: 'Password',
    placeholder: 'Add password',
    system: {
      name: 'password',
    },
    value: '',
    errors: [],
    type: 'text',
    name: 'password',
    rules: {
      title: 'Password field',
      required: true,
    }
  },
  email: {
    label: 'Email',
    placeholder: 'Add email',
    value: '',
    system: {
      name: 'email',
    },
    errors: [],
    type: 'email',
    name: 'email',
    rules: {
      title: 'Email field',
      required: true,
      email: true,
    }
  },
  phone: {
    label: 'Phone',
    placeholder: 'Add phone',
    system: {
      name: 'phone',
    },
    value: '',
    errors: [],
    type: 'text',
    name: 'phone',
    rules: {
      title: 'Phone field',
    }
  },
  signature: {
    label: 'Signature',
    placeholder: 'Add signature',
    system: {
      name: 'signature',
    },
    value: '',
    errors: [],
    type: 'text',
    name: 'signature',
    rules: {
      title: 'Signature field'
    }
  }
};



// WEBPACK FOOTER //
// ./src/containers/PeopleAdd/fields.js